import { useState } from "react";
import { INIT_FILTER_FIELDS } from "../constants";

const useFilters = () => {
    //#region States
    const [filters, setFilters] = useState({ ...INIT_FILTER_FIELDS });
    //#endregion
    //#region Functions
    const changeFilter = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    }
    const clearFilters = () => {
        setFilters({ ...INIT_FILTER_FIELDS });
    }
    const filtersAreCompleted = () => {
        return Boolean(
            filters.title && 
            filters.date > -1);
    }
    const checkClearedFilterFields = () => {
        const clearedFilterFields = Object.keys(filters).every(key => {
            return filters[key] === INIT_FILTER_FIELDS[key];
        });
        return clearedFilterFields;
    }
    //#endregion
    return {
        value: filters,
        change: changeFilter,
        clear: clearFilters,
        areCompleted: filtersAreCompleted,
        isCleared: checkClearedFilterFields
    };
}

export default useFilters;